/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileHtm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M9.013 14.006h2.056v-2.023h1.076V17H11.07v-2.084H9.013V17H7.937v-5.017h1.076zm7.893-1.111h-1.483V17h-1.076v-4.106h-1.484v-.91h4.043zm3.44 2.395 1.572-3.307h1.125V17H21.98v-3.249l-1.325 2.766h-.662l-1.325-2.723V17h-1.042v-5.017h1.125z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileHtm as FileHtm };
